// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";

Alpine.directive("card-double-column", (element, {}, { cleanup }) => {
  const dom = {
    expandBtn: ensureHTMLElement(element.querySelector(".c-cards-double-column__card-expand-btn")),
  };

  function toggleContent(e: Event) {
    const target = e.target as HTMLElement;
    // If the card button is clicked, we don't toggle the content
    if (target.closest(".c-cards-double-column__card-button")) return;
    // Don't do anything on desktop
    if (viewport.width >= 1024) return;

    const isExpand = element.classList.contains("c-cards-double-column__card--expanded");
    const icon = dom.expandBtn.querySelector(".c-icon");
    if (isExpand) {
      element.classList.remove("c-cards-double-column__card--expanded");
      icon?.classList.add("c-icon--add");
      icon?.classList.remove("c-icon--supp");
    } else {
      element.classList.add("c-cards-double-column__card--expanded");
      icon?.classList.remove("c-icon--add");
      icon?.classList.add("c-icon--supp");
    }
  }

  element.addEventListener("click", toggleContent);

  cleanup(() => {
    element.removeEventListener("click", toggleContent);
  });
});
